// extracted by mini-css-extract-plugin
export default {"refresh":"Rotate_refresh__PaRkf","container":"Rotate_container__PcmLh","refresh_image":"Rotate_refresh_image__MOxHV","rotate360":"Rotate_rotate360__dR8pW"};